import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import Bowser from 'bowser';
import { v4 } from 'uuid';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

// Note: Keep the enums Alphabetically Sorted
/**
 * Package name and version.
 * Needs to be updated in time of merge. Please see readme.md file.
 * Sample values: PackageVersion, PackageName
 */
var PackageInformation;
(function (PackageInformation) {
  PackageInformation["PackageVersion"] = "2.0.10";
  PackageInformation["PackageName"] = "@mwt/web-js-telemetry";
})(PackageInformation || (PackageInformation = {}));
/**
 * How a panel was opened up
 * Sample values: nav, notification, direct, toast, userInitiated, update,
 * login, appNav, redererTerminated
 */
var PanelLaunchMethod;
(function (PanelLaunchMethod) {
  PanelLaunchMethod["ActivityFeed"] = "activityFeed";
  PanelLaunchMethod["AppNav"] = "appNav";
  PanelLaunchMethod["Direct"] = "direct";
  PanelLaunchMethod["Nav"] = "nav";
  PanelLaunchMethod["Notification"] = "notification";
  PanelLaunchMethod["Posts"] = "posts";
  PanelLaunchMethod["Toast"] = "toast";
  PanelLaunchMethod["Update"] = "update";
  PanelLaunchMethod["UserInitiated"] = "userInitiated";
})(PanelLaunchMethod || (PanelLaunchMethod = {}));
var EventBaseType;
(function (EventBaseType) {
  /**
   * casing is matching teams implementation
   */
  EventBaseType["PanelAction"] = "panelaction";
  /**
   * casing is matching teams implementation
   */
  EventBaseType["PanelView"] = "panelview";
})(EventBaseType || (EventBaseType = {}));
var EventType;
(function (EventType) {
  EventType["HttpEvent"] = "http";
  EventType["Scenario"] = "scenario";
  EventType["Trace"] = "trace";
  EventType["UserBI"] = "userbi";
  EventType["Performance"] = "performance";
})(EventType || (EventType = {}));
var ActionGesture;
(function (ActionGesture) {
  ActionGesture["Click"] = "click";
  ActionGesture["Hover"] = "hover";
  ActionGesture["KeyPress"] = "keypress";
  ActionGesture["None"] = "none";
  ActionGesture["Scroll"] = "scroll";
})(ActionGesture || (ActionGesture = {}));
var UserBiColumns;
(function (UserBiColumns) {
  UserBiColumns["ActionOutcome"] = "Action.Outcome";
  UserBiColumns["Gesture"] = "Action.Gesture";
  UserBiColumns["ModuleName"] = "Module.Name";
  /**
   * Summary of the module's content. Should not include any channel name or team name.
   * Sample values: taskBarIcon item clicked, Send, chat toast, Minimize desktop app, show new messages button,
   * toast, Close/Minimize desktop app, app bar - chat, App bar - Teams
   */
  UserBiColumns["ModuleSummary"] = "Module.Summary";
  /**
   * How a panel was opened up. e.g. nav, notification, direct, toast, userInitiated, update, login, appNav, redererTerminated
   */
  UserBiColumns["PanelLaunchMethod"] = "Panel.LaunchMethod";
  /**
   * The region of the page the panel is located in (Ex: Panel_Type = Channel, Panel_Region = Main or Right)
   */
  UserBiColumns["PanelRegion"] = "Panel.Region";
  /**
   * Indicates which panel the action was performed in
   * Sample values: Chat, Channel, taskBarMenu, toast, teamList, chatlisList, activity, notification, documentStage,
   * offlineBanner,{other, alertList, chat, chatList, channel, teamChannelList, meSpace, calendar, calendarList,
   * replyChain, files, fileSources, call, document, team, toast}
   */
  UserBiColumns["PanelType"] = "Panel.Type";
  /**
   * Optional property. Literal URL to reach the loaded panel
   */
  UserBiColumns["PanelUri"] = "Panel.Uri";
  /**
   * Classifies the scenario driven by a panel action. (Ex: Action_Scenario = "composeSendMessage"
   * is logged when a user clicks on the compose message button)
   */
  UserBiColumns["Scenario"] = "Action.Scenario";
  /**
   * Classifies the type of action scenario (Ex: Action_Scenario = "openFile", Action_ScenarioType = "files")
   */
  UserBiColumns["ScenarioType"] = "Action.ScenarioType";
})(UserBiColumns || (UserBiColumns = {}));
var ContextColumnsBase;
(function (ContextColumnsBase) {
  ContextColumnsBase["AppId"] = "App.Id";
  ContextColumnsBase["AppInfoArchVersion"] = "AppInfo.ArchVersion";
  ContextColumnsBase["AppInfoClientType"] = "AppInfo.ClientType";
  ContextColumnsBase["AppInfoEnvironment"] = "AppInfo.Environment";
  ContextColumnsBase["AppInfoExpIds"] = "AppInfo.ExpIds";
  ContextColumnsBase["AppInfoExperienceName"] = "AppInfo.ExperienceName";
  ContextColumnsBase["AppInfoHostAppVersion"] = "AppInfo.HostAppVersion";
  ContextColumnsBase["AppInfoLanguage"] = "AppInfo.Language";
  ContextColumnsBase["AppInfoLocale"] = "AppInfo.Locale";
  ContextColumnsBase["AppInfoPlatformId"] = "AppInfo.PlatformId";
  ContextColumnsBase["AppInfoProcessArchitecture"] = "AppInfo.ProcessArchitecture";
  ContextColumnsBase["AppInfoVersion"] = "AppInfo.Version";
  ContextColumnsBase["AppInfoWebVersion"] = "AppInfo.WebVersion";
  ContextColumnsBase["DeviceInfoId"] = "DeviceInfo.Id";
  ContextColumnsBase["DeviceInfoOsName"] = "DeviceInfo.OsName";
  ContextColumnsBase["DeviceInfoOsVersion"] = "DeviceInfo.OsVersion";
  ContextColumnsBase["DeviceInfoMake"] = "DeviceInfo.Make";
  ContextColumnsBase["DeviceInfoModel"] = "DeviceInfo.Model";
  ContextColumnsBase["DeviceInfoNetworkProvider"] = "DeviceInfo.NetworkProvider";
  ContextColumnsBase["EventInfoIsSNS"] = "EventInfo.isNS";
  ContextColumnsBase["LoggerVersion"] = "Logger.Version";
  ContextColumnsBase["LoggerIsCollectorUrlCompliant"] = "Logger.isCollectorUrlCompliant";
  ContextColumnsBase["PanelContext"] = "Panel.Context";
  ContextColumnsBase["PanelWindowID"] = "Panel.WindowID";
  ContextColumnsBase["SessionId"] = "Session.Id";
  ContextColumnsBase["StartReason"] = "startReason";
  /**
   * Browser UserAgent
   */
  ContextColumnsBase["UserAgent"] = "userAgent";
  ContextColumnsBase["UserInfoETag"] = "UserInfo.ETag";
  ContextColumnsBase["UserInfoHostETag"] = "UserInfo.HostETag";
  ContextColumnsBase["UserInfoId"] = "UserInfo.Id";
  ContextColumnsBase["UserInfoLanguage"] = "UserInfo.Language";
  ContextColumnsBase["UserInfoLicenseType"] = "UserInfo.LicenseType";
  ContextColumnsBase["UserInfoMsaId"] = "UserInfo.MsaId";
  ContextColumnsBase["UserInfoRegion"] = "UserInfo.Region";
  ContextColumnsBase["UserInfoTenantId"] = "UserInfo.TenantId";
  ContextColumnsBase["UserInfoTenantRole"] = "UserInfo.TenantRole";
  ContextColumnsBase["UserRole"] = "userRole";
  ContextColumnsBase["UserType"] = "userType";
  ContextColumnsBase["WindowId"] = "WindowId";
  ContextColumnsBase["WindowType"] = "Window.Type";
})(ContextColumnsBase || (ContextColumnsBase = {}));
var SeverityLevel;
(function (SeverityLevel) {
  SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
  SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
  SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
  SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
  SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
/**
 * The region of the page the panel is located
 * in (Ex: Panel_Type = Channel, Panel.Region = Main or Right)
 * Note: Keep the enums Alphabetically Sorted
 */
var PanelRegion;
(function (PanelRegion) {
  PanelRegion["Banner"] = "banner";
  PanelRegion["Dialog"] = "dialog";
  PanelRegion["Footer"] = "footer";
  PanelRegion["Header"] = "header";
  PanelRegion["Left"] = "left";
  PanelRegion["Main"] = "main";
  PanelRegion["Modal"] = "modal";
  PanelRegion["Popover"] = "popover";
  PanelRegion["Right"] = "right";
  PanelRegion["Toast"] = "toast";
  PanelRegion["Virtual"] = "virtual";
})(PanelRegion || (PanelRegion = {}));
var PanelViewOutcome;
(function (PanelViewOutcome) {
  PanelViewOutcome["Failure"] = "failure";
  PanelViewOutcome["Init"] = "init";
  PanelViewOutcome["None"] = "none";
  PanelViewOutcome["Success"] = "success";
})(PanelViewOutcome || (PanelViewOutcome = {}));
/**
 * Outcome of action taken
 * (Ex: Action_Outcome = "read" is logged when "scroll" action happens)
 * Note: Keep the enums Alphabetically Sorted
 */
var PanelActionOutcome;
(function (PanelActionOutcome) {
  PanelActionOutcome["CopyToClipboard"] = "copyToClipboard";
  PanelActionOutcome["Disable"] = "disable";
  PanelActionOutcome["DismissBanner"] = "dismissBanner";
  PanelActionOutcome["Enable"] = "enable";
  PanelActionOutcome["Hide"] = "hide";
  PanelActionOutcome["Inspect"] = "inspect";
  PanelActionOutcome["Launch"] = "launch";
  PanelActionOutcome["Nav"] = "nav";
  PanelActionOutcome["None"] = "none";
  PanelActionOutcome["OpenChat"] = "openChat";
  PanelActionOutcome["OpenDialog"] = "openDialog";
  PanelActionOutcome["OpenPopup"] = "openPopup";
  PanelActionOutcome["Read"] = "read";
  PanelActionOutcome["RemoveBanner"] = "removeBanner";
  PanelActionOutcome["RemoveChiclet"] = "removeChiclet";
  PanelActionOutcome["Retry"] = "retry";
  PanelActionOutcome["Select"] = "select";
  PanelActionOutcome["Show"] = "show";
  PanelActionOutcome["ShowBanner"] = "showBanner";
  PanelActionOutcome["Submit"] = "submit";
  PanelActionOutcome["Toggle"] = "toggle";
  PanelActionOutcome["Update"] = "update";
})(PanelActionOutcome || (PanelActionOutcome = {}));
var ScenarioColumns;
(function (ScenarioColumns) {
  ScenarioColumns["Delta"] = "delta";
  ScenarioColumns["Elapsed"] = "elapsed";
  ScenarioColumns["Error"] = "error";
  ScenarioColumns["ErrorCode"] = "errorCode";
  ScenarioColumns["ScenarioName"] = "Scenario.Name";
  ScenarioColumns["ScenarioStatus"] = "Scenario.Status";
  ScenarioColumns["ScenarioStep"] = "Scenario.Step";
  ScenarioColumns["StartReason"] = "startReason";
  ScenarioColumns["StatusCode"] = "statusCode";
  ScenarioColumns["StepDelta"] = "stepDelta";
})(ScenarioColumns || (ScenarioColumns = {}));
var TelemetryScenarioStatus;
(function (TelemetryScenarioStatus) {
  TelemetryScenarioStatus["Abandoned"] = "abandoned";
  TelemetryScenarioStatus["Failure"] = "failure";
  TelemetryScenarioStatus["Incomplete"] = "incomplete";
  TelemetryScenarioStatus["Init"] = "init";
  TelemetryScenarioStatus["Success"] = "success";
  TelemetryScenarioStatus["Timeout"] = "timeout";
})(TelemetryScenarioStatus || (TelemetryScenarioStatus = {}));
var TelemetryScenarioStep;
(function (TelemetryScenarioStep) {
  TelemetryScenarioStep["Finish"] = "finish";
  TelemetryScenarioStep["Pause"] = "pause";
  TelemetryScenarioStep["Start"] = "start";
  TelemetryScenarioStep["Test"] = "test";
})(TelemetryScenarioStep || (TelemetryScenarioStep = {}));
var HttpColumns;
(function (HttpColumns) {
  HttpColumns["ClientRequestId"] = "clientRequestId";
  HttpColumns["ContentLength"] = "contentLength";
  HttpColumns["Duration"] = "duration";
  HttpColumns["Hostname"] = "hostname";
  HttpColumns["Method"] = "method";
  HttpColumns["NetworkState"] = "networkState";
  HttpColumns["Payload"] = "payload";
  HttpColumns["Redirect"] = "redirect";
  HttpColumns["RequestCreatedTime"] = "requestCreatedTime";
  HttpColumns["RequestResult"] = "requestResult";
  HttpColumns["ResultCode"] = "resultCode";
  HttpColumns["Start"] = "start";
  HttpColumns["ReqStart"] = "reqStart";
  HttpColumns["RespStart"] = "respStart";
})(HttpColumns || (HttpColumns = {}));
var NetworkState;
(function (NetworkState) {
  NetworkState["Offline"] = "offline";
  NetworkState["Online"] = "online";
})(NetworkState || (NetworkState = {}));

var applyAppContext = function applyAppContext(properties, context) {
  var appInfoLang = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.AppInfoLanguage];
  var appInfoVersion = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.AppInfoVersion];
  if (appInfoLang) {
    context.app.locale = appInfoLang;
  }
  if (appInfoVersion) {
    context.app.ver = appInfoVersion;
  }
};
var applyUserContext = function applyUserContext(properties, context) {
  var userInfoId = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.UserInfoId];
  var userInfoLanguage = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.UserInfoLanguage];
  if (userInfoId) {
    context.user.id = userInfoId;
    context.user.localId = "a:".concat(userInfoId); // Docs - https://1dsdocs.azurewebsites.net/schema/Types/UserId.html#kinds-of-ids
  }

  if (userInfoLanguage) {
    context.user.locale = userInfoLanguage;
  }
};
var applyDeviceContext = function applyDeviceContext(properties, context) {
  var localId = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.DeviceInfoId];
  var make = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.DeviceInfoMake];
  var model = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.DeviceInfoModel];
  if (localId) {
    context.device.localId = localId;
  }
  if (make) {
    context.device.make = make;
  }
  if (model) {
    context.device.model = model;
  }
};
var applySessionContext = function applySessionContext(properties, context) {
  var sesId = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.SessionId];
  if (sesId) {
    context.session.id = sesId;
  }
};
var applyOSContext = function applyOSContext(properties, context) {
  var version = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.DeviceInfoOsVersion];
  var name = properties === null || properties === void 0 ? void 0 : properties[ContextColumnsBase.DeviceInfoOsName];
  if (version) {
    context.os.ver = version;
  }
  if (name) {
    context.os.name = name;
  }
};
var applyCustomContext = function applyCustomContext(properties, ctxMgr) {
  for (var property in properties) {
    ctxMgr.setProperty(property, properties[property]);
  }
};

var projectName = 'TeamsClientMwtPackages';
function getTelemetryUrlEcsConfig(tenantId) {
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch("https://config.teams.microsoft.com/config/v1/MicrosoftTeams/1.0.0.0?agents=".concat(projectName, "&TenantID=").concat(tenantId))];
        case 1:
          result = _a.sent();
          return [4 /*yield*/, result.json()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}

var TelemetryResponse = /** @class */function () {
  /**
   *
   */
  function TelemetryResponse(telemetryRegion, telemetryUrl) {
    this.telemetryRegion = telemetryRegion;
    this.telemetryUrl = telemetryUrl;
  }
  return TelemetryResponse;
}();

// Stores telemetry response by tenant id to prevent JavaScript exception when using multiple compliant telemetry clients:
//   - ECS client will throw an exception when trying to initialize an already loaded configuration.
var telemetryResponseByTenantId = new Map();
var loadTelemetryRegion = function loadTelemetryRegion(tenantId, logToConsole) {
  if (logToConsole === void 0) {
    logToConsole = false;
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var resp, telemetryModel, error_1;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (telemetryResponseByTenantId.has(tenantId)) {
            return [2 /*return*/, Promise.resolve(telemetryResponseByTenantId.get(tenantId))];
          }
          _b.label = 1;
        case 1:
          _b.trys.push([1, 3,, 4]);
          return [4 /*yield*/, getTelemetryUrlEcsConfig(tenantId)];
        case 2:
          resp = _b.sent();
          // telemetryUrl for US region is empty. So only checking telemetry region since it shouldn't be null.
          if (!((_a = resp === null || resp === void 0 ? void 0 : resp.TeamsClientMwtPackages) === null || _a === void 0 ? void 0 : _a.TelemetryRegion)) {
            // This check is to catch any malformed ECS response (like the one that caused Teams outage of 2022)
            throw new Error('Telemetry region or url is not defined');
          }
          telemetryModel = new TelemetryResponse(resp.TeamsClientMwtPackages.TelemetryRegion, resp.TeamsClientMwtPackages.TelemetryUrl);
          telemetryResponseByTenantId.set(tenantId, telemetryModel);
          return [2 /*return*/, telemetryModel];
        case 3:
          error_1 = _b.sent();
          if (logToConsole) {
            console.log(error_1.message + error_1.stack);
          }
          throw error_1;
        case 4:
          return [2 /*return*/];
      }
    });
  });
};

var AriaTelemetryClient = /** @class */function () {
  function AriaTelemetryClient(config, logToConsole) {
    if (logToConsole === void 0) {
      logToConsole = false;
    }
    this._isEndpointCompliant = false;
    this._isBufferForced = false;
    this._config = __assign({
      disableCookiesUsage: true,
      propertyStorageOverride: {
        getProperty: function getProperty(key) {
          return sessionStorage.getItem.bind(sessionStorage)(key) || '';
        },
        setProperty: sessionStorage.setItem.bind(sessionStorage)
      }
    }, config);
    this._config.enableCompoundKey = true;
    this._logToConsole = logToConsole;
    this._analytics = new ApplicationInsights();
    this._analytics.initialize(this._config, []);
  }
  AriaTelemetryClient.prototype.isInitialized = function () {
    return this._analytics.isInitialized();
  };
  AriaTelemetryClient.prototype.isEUDBCompliant = function () {
    return this._isEndpointCompliant;
  };
  AriaTelemetryClient.prototype.isBufferForced = function () {
    return this._isBufferForced;
  };
  AriaTelemetryClient.prototype.setBufferForced = function (isBufferForced) {
    this._isBufferForced = isBufferForced;
  };
  AriaTelemetryClient.prototype.getClient = function () {
    return this._analytics;
  };
  AriaTelemetryClient.prototype.getCompliantAriaClient = function (tenantId, config) {
    var _this = this;
    // forcing to buffer here since we don't have compliant telemetry region yet
    // we're only setting this buffer here as forced, and since after the update
    // in the telemetry client, we're going to delete this client. So It'll not
    // be forced anymore.
    this._isBufferForced = true;
    return loadTelemetryRegion(tenantId).then(function (telemetryInfo) {
      //checking telemetry URL since it might be empty/null.
      if (telemetryInfo.telemetryUrl) {
        config.endpointUrl = telemetryInfo.telemetryUrl;
      }
      var newClient = new AriaTelemetryClient(config, true);
      newClient._isEndpointCompliant = true;
      return newClient;
    }).catch(function (error) {
      _this.logException(error, SeverityLevel.Error);
      _this.flush();
      _this._isBufferForced = false;
      throw error;
    });
  };
  AriaTelemetryClient.prototype.setCommonProperties = function (properties) {
    if (this._logToConsole) {
      console.log("[AriaTelemetryClient][setCommonProperties]: properties ", properties);
    }
    var context = this._analytics.getPropertyManager().getPropertiesContext();
    applyAppContext(properties, context);
    applyUserContext(properties, context);
    applyDeviceContext(properties, context);
    applyOSContext(properties, context);
    applySessionContext(properties, context);
  };
  AriaTelemetryClient.prototype.setCustomProperties = function (properties) {
    if (this._logToConsole) {
      console.log("[AriaTelemetryClient][setCustomProperties]: properties ", properties);
    }
    var ctxMgr = this._analytics.getPropertyManager();
    applyCustomContext(properties, ctxMgr);
  };
  AriaTelemetryClient.prototype.logUIEvent = function (event) {
    // Set user-bi specific columns on telemetry client.
    var eventName = EventType.UserBI;
    var eventType = event.eventName;
    var oneDsEventProperties = this._convertToAriaProperties(eventName, event.properties);
    this._analytics.trackEvent(__assign(__assign({}, oneDsEventProperties), {
      baseType: eventType
    }));
  };
  AriaTelemetryClient.prototype.logScenario = function (event) {
    var eventName = EventType.Scenario;
    var oneDsEventProperties = this._convertToAriaProperties(eventName, event.properties);
    this._analytics.trackEvent(oneDsEventProperties);
  };
  AriaTelemetryClient.prototype.logHttpEvent = function (event) {
    var _a;
    var eventName = (_a = event.eventType) !== null && _a !== void 0 ? _a : EventType.HttpEvent;
    var oneDsEventProperties = this._convertToAriaProperties(eventName, event.properties);
    this._analytics.trackEvent(oneDsEventProperties);
  };
  AriaTelemetryClient.prototype.logPageView = function (event) {
    this._analytics.trackPageView({
      name: event.properties.name,
      pageType: event.properties.pageType,
      uri: event.properties.uri,
      refUri: event.properties.refUri,
      properties: event.properties.properties
    });
  };
  AriaTelemetryClient.prototype.logException = function (error, severityLevel, properties) {
    this._analytics.trackException({
      exception: error,
      properties: properties,
      severityLevel: severityLevel
    });
  };
  AriaTelemetryClient.prototype.logTrace = function (message, severityLevel, properties) {
    this._analytics.trackEvent({
      name: EventType.Trace,
      data: __assign(__assign({}, properties), {
        traceLevel: severityLevel,
        logMessage: message
      })
    });
  };
  AriaTelemetryClient.prototype.logEvent = function (eventName, properties) {
    var oneDsEventProperties = this._convertToAriaProperties(eventName, properties);
    this._analytics.trackEvent(oneDsEventProperties);
  };
  AriaTelemetryClient.prototype.flush = function (callback) {
    callback === null || callback === void 0 ? void 0 : callback();
    this._analytics.emptySnippetQueue({
      config: this._config
    });
  };
  AriaTelemetryClient.prototype._convertToAriaProperties = function (name, properties) {
    var eventProperties = {
      data: {},
      name: name
    };
    for (var propertyKey in properties) {
      if (eventProperties.data) {
        var propertyValue = properties === null || properties === void 0 ? void 0 : properties[propertyKey];
        var propertyName = propertyKey.replace(' ', '');
        eventProperties.data[propertyName] = propertyValue;
      }
    }
    return eventProperties;
  };
  return AriaTelemetryClient;
}();

var BUFFER_QUEUE_SIZE = 100;

/**
 * Buffers events in a queue and sends to telemetry.
 */
var TelemetryEventBuffer = /** @class */function () {
  function TelemetryEventBuffer() {
    this._bufferQueue = [];
    this._bufferSize = BUFFER_QUEUE_SIZE;
  }
  /***
   * Initializes the buffer queue with a max size of 100.
   * The buffer queue is flushed on call of flush method whichever happens first.
   */
  TelemetryEventBuffer.prototype.getInstance = function () {
    if (!this._instance) {
      this._instance = new TelemetryEventBuffer();
    }
    return this._instance;
  };
  /***
   * Empty's the event buffer queue.
   * Empty's the event buffer queue.
   * @param callback optional method to call after the event buffer queue is emptied.
   */
  TelemetryEventBuffer.prototype.flushTelemetryEventBuffer = function (callback) {
    this._bufferQueue = [];
    callback === null || callback === void 0 ? void 0 : callback();
  };
  /***
   * Adds event log to the event buffer queue.
   * @param event logged event.
   */
  TelemetryEventBuffer.prototype.addToTelemetryEventBuffer = function (eventBuffer) {
    if (this._bufferQueue.length === this._bufferSize) {
      this._bufferQueue.shift();
    }
    this._bufferQueue.push(eventBuffer);
  };
  /***
   * pushes the events to telemetry client and flushes the event queue.
   */
  TelemetryEventBuffer.prototype.pushEventsToTelemetryClient = function () {
    this._bufferQueue.map(function (event) {
      event();
    });
    this.flushTelemetryEventBuffer();
  };
  /***
   * Return the events queue size.
   */
  TelemetryEventBuffer.prototype.getTelemetryEventBufferSize = function () {
    return this._bufferQueue.length;
  };
  return TelemetryEventBuffer;
}();
var telemetryEventBuffer = new TelemetryEventBuffer().getInstance();

var telemetryClients = [];
var hasTelemetryClients = false;
// Hash to hold all the instrumentation
// keys with their index in order to delete them
var instrumentationKeys = new Map();
var getClients = function getClients() {
  return telemetryClients;
};
/**
 * Adds a TelemetryClient object to the `telemetryClients` to send
 * UI/Non-UI events through the pipeline.
 * @param {TelemetryClient} [telemetryClient] telemetry client object.
 * @param {boolean} [logToConsole] - Parameter to log info and errors to console. Defaults to false.
 */
var initializeTelemetryClient = function initializeTelemetryClient(telemetryClient, logToConsole) {
  if (logToConsole === void 0) {
    logToConsole = false;
  }
  if (!(telemetryClient === null || telemetryClient === void 0 ? void 0 : telemetryClient.getClient().config.instrumentationKey) && !(telemetryClient === null || telemetryClient === void 0 ? void 0 : telemetryClient.getClient().config.connectionString)) {
    if (logToConsole) {
      console.error("[telemetryClients] Instrumentation key or connection string not found.");
    }
  } else {
    telemetryClients.push(telemetryClient);
    instrumentationKeys.set(telemetryClient === null || telemetryClient === void 0 ? void 0 : telemetryClient.getClient().config.instrumentationKey, telemetryClients.length - 1);
    hasTelemetryClients = telemetryClients.length > 0;
  }
  if (hasTelemetryClients) {
    if (logToConsole) {
      console.log("[telemetryClients]: Clients initialized. Logging events to collector.");
      console.log("[telemetryClients]: URL: ".concat(telemetryClient === null || telemetryClient === void 0 ? void 0 : telemetryClient.getClient().config.endpointUrl));
    }
    // Push queued logs from buffer to collector after initializing telemetry clients.
    telemetryEventBuffer.pushEventsToTelemetryClient();
  }
};
/**
 * Update to compliant Aria telemetry client.
 * This function is created to log events to compliant endpoint.
 * And log that value via logger.
 * @param {TelemetryClient} [telemetryClient] telemetry client object.
 */
var updateToCompliantAriaClient = function updateToCompliantAriaClient(telemetryClient, logToConsole) {
  if (logToConsole === void 0) {
    logToConsole = false;
  }
  var instrumentationKey = telemetryClient === null || telemetryClient === void 0 ? void 0 : telemetryClient.getClient().config.instrumentationKey;
  var indexInArray = instrumentationKeys.get(instrumentationKey);
  if (logToConsole) {
    instrumentationKey ? console.log("[telemetryClients][updateToCompliantAriaClient] instrumentation key gathered. Finding client to update") : console.log("[telemetryClients][updateToCompliantAriaClient] instrumentation key cannot gathered.");
  }
  if (telemetryClients.length > 0 && instrumentationKeys.has(instrumentationKey)) {
    telemetryClients.splice(indexInArray, 1);
    instrumentationKeys.delete(instrumentationKey);
  } else {
    telemetryClients[0].setBufferForced(false);
    if (logToConsole) {
      console.log("[telemetryClients]updateToCompliantAriaClient] Tried to update an Aria Client that does not exists. Cannot be updated.");
      console.log("[telemetryClients] Tried to update an Aria Client that does not exists. Cannot be updated. Instrumentation key: ".concat(instrumentationKey));
    }
    return;
  }
  initializeTelemetryClient(telemetryClient, true);
};
/**
 * Logs the common properties for Part A schema.
 * @param {Partial<TelemetryContext>} [properties] telemetry context pertaining to the common Part A schema.
 */
var setCommonProperties = function setCommonProperties(properties) {
  var setPartAProperties = function setPartAProperties() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.setCommonProperties(properties);
    });
  };
  queueEvent(setPartAProperties);
};
/**
 * Logs the custom properties to be send with every event.
 * @param {Partial<TelemetryContext>} [properties] Additional fields to be send with every event.
 */
var setCustomProperties = function setCustomProperties(properties) {
  var customProperties = function customProperties() {
    return telemetryClients.forEach(function (telemetryClient) {
      properties['Logger.isCollectorUrlCompliant'] = telemetryClient.isEUDBCompliant();
      telemetryClient.setCustomProperties(properties);
    });
  };
  queueEvent(customProperties);
};
/**
 * Logs UI action or event.
 * @param {UserBIEvent<T & Partial<TelemetryContext>>} [event] userbi event
 */
var logUIEvent = function logUIEvent(event) {
  var userbiEvent = function userbiEvent() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logUIEvent(event);
    });
  };
  queueEvent(userbiEvent);
};
/**
 * Logs a scenario for business telemetry indicators.
 * @param {ScenarioEvent<T & Partial<TelemetryContext>>} [event] - properties for the scenario e.g. step, elapsed, delta etc.
 */
var logScenarioEvent = function logScenarioEvent(event) {
  var scenarioEvent = function scenarioEvent() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logScenario(event);
    });
  };
  queueEvent(scenarioEvent);
};
/**
 * Logs a http request for operational telemetry indicators.
 * @param {HttpEvent<T & Partial<TelemetryContext>>} [event] - properties for the event e.g. method, hostname etc.
 */
var logHttpEvent = function logHttpEvent(event) {
  var httpEvent = function httpEvent() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logHttpEvent(event);
    });
  };
  queueEvent(httpEvent);
};
/**
 * Logs that a page, or a container is displayed to the user
 */
var logPageView = function logPageView(event) {
  var pageViewEvent = function pageViewEvent() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logPageView(event);
    });
  };
  queueEvent(pageViewEvent);
};
/**
 * Logs an exception that has been caught
 */
var logException = function logException(error, severityLevel, properties) {
  var event = function event() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logException(error, severityLevel, properties);
    });
  };
  queueEvent(event);
};
/**
 * Logs a diagnostic trace message such as entering or leaving a function
 */
var logTrace = function logTrace(message, severityLevel, properties) {
  if (severityLevel === void 0) {
    severityLevel = SeverityLevel.Information;
  }
  var event = function event() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logTrace(message, severityLevel, properties);
    });
  };
  queueEvent(event);
};
/**
 * Logs custom events.
 * @param eventName event name.
 * @param properties key value pairs sent to the `logEvent` method.
 */
var logEvent = function logEvent(eventName, properties) {
  var logEvent = function logEvent() {
    return telemetryClients.forEach(function (telemetryClient) {
      telemetryClient.logEvent(eventName, properties);
    });
  };
  queueEvent(logEvent);
};
/**
 * Manually triggers an immediate send of all telemetry information
 * that is still in the buffer.
 */
var flushTelemetry = function flushTelemetry(callback) {
  telemetryClients.forEach(function (telemetryClient) {
    if (telemetryClient.isInitialized()) {
      telemetryClient.flush(callback);
    }
  });
  hasTelemetryClients = false;
};
/**
 * Pushes the log event to LogBuffer if telemetry has not been initialized
 * or push the events to ARIA.
 * @param callback event callback to be queued.
 */
var queueEvent = function queueEvent(callback) {
  !hasTelemetryClients || telemetryClients.filter(function (e) {
    return e.isBufferForced() === true;
  }).length > 0 ? telemetryEventBuffer.addToTelemetryEventBuffer(callback) : callback();
};

/**
 * Reference:
 *@link https://domoreexp.visualstudio.com/Teamspace/_git/teams-modular-packages?path=%2Fpackages%2Fcore%2Fservices%2Fcore-services-platform%2Fsrc%2Fplatform-service.test.ts&version=GBmaster&_a=contents
 */
var PlatformId;
(function (PlatformId) {
  PlatformId[PlatformId["Android"] = 1416] = "Android";
  PlatformId[PlatformId["Desktop"] = 27] = "Desktop";
  PlatformId[PlatformId["IOS"] = 1417] = "IOS";
  PlatformId[PlatformId["Linux"] = 41] = "Linux";
  PlatformId[PlatformId["Mac"] = 28] = "Mac";
  PlatformId[PlatformId["Rigel"] = 34] = "Rigel";
  PlatformId[PlatformId["Web"] = 1415] = "Web";
  PlatformId[PlatformId["WindowsPhone"] = 1423] = "WindowsPhone";
})(PlatformId || (PlatformId = {}));
var ClientType;
(function (ClientType) {
  ClientType["CDLWorker"] = "cdlworker";
  ClientType["Desktop"] = "desktop";
  ClientType["Web"] = "web";
})(ClientType || (ClientType = {}));
/**
 * Reference:
 * @link https://github.com/lancedikson/bowser/blob/master/src/constants.js
 * */
var OsNames;
(function (OsNames) {
  OsNames["Android"] = "Android";
  OsNames["Bada"] = "Bada";
  OsNames["BlackBerry"] = "BlackBerry";
  OsNames["ChromeOS"] = "Chrome OS";
  OsNames["Linux"] = "Linux";
  OsNames["MacOS"] = "macOS";
  OsNames["PlayStation4"] = "PlayStation 4";
  OsNames["Roku"] = "Roku";
  OsNames["Tizen"] = "Tizen";
  OsNames["WebOS"] = "WebOS";
  OsNames["Windows"] = "Windows";
  OsNames["WindowsPhone"] = "Windows Phone";
  OsNames["iOS"] = "iOS";
})(OsNames || (OsNames = {}));
var getClientType = function getClientType() {
  var userAgent = window.navigator.userAgent;
  return (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('Electron')) !== -1 ? ClientType.Desktop : (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('cdlworker')) !== -1 ? ClientType.CDLWorker : ClientType.Web;
};
var getOsPlatformId = function getOsPlatformId() {
  var clientType = getClientType();
  var userAgent = window.navigator.userAgent;
  var osName = Bowser.getParser(userAgent).getOSName();
  if (OsNames.Linux === osName) {
    return PlatformId.Linux;
  } else if (OsNames.Android === osName) {
    return PlatformId.Android;
  } else if (OsNames.iOS === osName) {
    return PlatformId.IOS;
  } else if (OsNames.WindowsPhone === osName) {
    return PlatformId.WindowsPhone;
  } else if (OsNames.MacOS === osName) {
    return PlatformId.Mac;
  } else if (clientType === ClientType.Desktop) {
    return PlatformId.Desktop;
  } else if (clientType === ClientType.Web) {
    return PlatformId.Web;
  } else if (clientType === ClientType.CDLWorker) {
    return PlatformId.Rigel;
  }
};
var getNavigationProperties = function getNavigationProperties() {
  var calculatedProperties = {};
  calculatedProperties.appPlatformId = String(getOsPlatformId());
  calculatedProperties.userAgent = window.navigator.userAgent;
  calculatedProperties.clientType = getClientType();
  return calculatedProperties;
};

/**
 * Logs messages and events to telemetry, and optionally to console using logToConsole
 * NOTES: DO NOT USE THIS CLASS TO LOG ANY PII (Personally Identifiable Information)
 *
 * Traces:
 *  debug: logs traces with verbose level
 *  info: logs traces with info level
 *  log: logs a general trace message
 *  warn: logs traces with warning level
 *  error: logs error traces. If the error is fatally critical (the app cannot
 *  function completely), set the severity to Critical
 *
 * Exception: logs an exception that has been caught. This also logs an error trace
 * Event: logs an event, such as a user scenario like clicking the email button, going to the next step
 * Page View: logs that a page is opened
 * Metric: logs metrics for performance indicators, and for alerts
 */
var Logger = /** @class */function () {
  function Logger() {}
  /**
   * @param {LoggingContext} [context] - Initializes logging context, sets the
   * part A schema properties in 1DS, along with other custom properites defined
   * by the application.
   * @param {boolean} [logToConsole] - Parameter to log all events to console along with telemetry. Defaults to false.
   */
  Logger.prototype.initialize = function (context, logToConsole) {
    if (context === void 0) {
      context = {};
    }
    if (logToConsole === void 0) {
      logToConsole = false;
    }
    this._logToConsole = logToConsole;
    if (this._logToConsole) {
      console.info("[Logger][initialize]: Initializing Logger with version:  ".concat(PackageInformation.PackageVersion));
    }
    this._context = this._moveTenantIdToCustomProperties(context);
    if (this._context.commonProperties) {
      // Initialize Part A schema.
      setCommonProperties(this._context.commonProperties);
    }
    if (this._context.customProperties) {
      this._applyContextProperties();
    }
  };
  /**
   * TODO - remove this private method in v2.0.6 after deprecating `UserInfoTenantId` from `commonProperties`
   */
  Logger.prototype._moveTenantIdToCustomProperties = function (context) {
    var _a;
    var _b;
    if (context === void 0) {
      context = {};
    }
    if ((_b = context.commonProperties) === null || _b === void 0 ? void 0 : _b[ContextColumnsBase.UserInfoTenantId]) {
      context.customProperties = __assign(__assign({}, context.customProperties), (_a = {}, _a[ContextColumnsBase.UserInfoTenantId] = context.commonProperties[ContextColumnsBase.UserInfoTenantId], _a));
    }
    return context;
  };
  /**
   * @returns singleton Logger instance.
   */
  Logger.getInstance = function () {
    if (!this._instance) {
      this._instance = new Logger();
    }
    return this._instance;
  };
  /**
   * @param {LoggingContext} [newCtx] - The new Logger context to be updated.
   * @returns updated Logger context object.
   */
  Logger.prototype.updateContext = function (newCtx) {
    this._context = this._moveTenantIdToCustomProperties(__assign(__assign({}, this._context), newCtx));
    if (newCtx.customProperties) {
      this._applyContextProperties();
    }
    if (newCtx.commonProperties) {
      // Update Part A schema on update.
      setCommonProperties(newCtx.commonProperties);
    }
  };
  Logger.prototype.getLoggerContext = function () {
    return this._context;
  };
  /**
   * Logs a debug trace message to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.debug = function (message, properties) {
    if (properties === void 0) {
      properties = {};
    }
    if (this._logToConsole) {
      console.debug("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logTrace(message, SeverityLevel.Verbose, properties);
  };
  /**
   * Logs an info trace message to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.info = function (message, properties) {
    if (properties === void 0) {
      properties = {};
    }
    if (this._logToConsole) {
      console.info("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logTrace(message, SeverityLevel.Information, properties);
  };
  /**
   * Logs a trace message to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.log = function (message, properties) {
    if (properties === void 0) {
      properties = {};
    }
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logTrace(message, SeverityLevel.Information, properties);
  };
  /**
   * Logs a warning trace message to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.warn = function (message, properties) {
    if (properties === void 0) {
      properties = {};
    }
    if (this._logToConsole) {
      console.warn("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logTrace(message, SeverityLevel.Warning, properties);
  };
  /**
   * Logs an error trace message to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.error = function (message, severity, properties) {
    if (severity === void 0) {
      severity = SeverityLevel.Error;
    }
    if (properties === void 0) {
      properties = {};
    }
    if (this._logToConsole) {
      console.error("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logTrace(message, severity, properties);
  };
  /**
   * Logs an exception that has been caught to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logException = function (error, errorMessage, severity, properties) {
    if (severity === void 0) {
      severity = SeverityLevel.Error;
    }
    if (properties === void 0) {
      properties = {};
    }
    var message = errorMessage !== null && errorMessage !== void 0 ? errorMessage : '';
    if (this._logToConsole) {
      console.error('[Error]: ', error);
      console.error("[".concat(new Date().toUTCString(), "] ").concat(message), properties);
    }
    logException(error, severity, __assign(__assign({}, properties), {
      message: message
    }));
    logTrace("".concat(message, ": ").concat(error === null || error === void 0 ? void 0 : error.message), severity, properties);
  };
  /**
   * Logs custom events to telemetry and optionally to console
   * @param eventName event name.
   * @param properties properties for the event in schema Part C.
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logEvent = function (eventName, properties) {
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] eventName: ").concat(eventName), properties);
    }
    logEvent(eventName, properties);
  };
  /**
   * Logs a UI panel action telemetry to telemetry and optionally to console.
   * Should be used when a user performs actions on e.g. click, scroll, hover etc.
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logPanelActionEvent = function (properties) {
    var panelActionProperties = this._getPanelActionColumns(properties);
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] ").concat(EventBaseType.PanelAction, ": "), panelActionProperties);
    }
    logUIEvent({
      eventName: EventBaseType.PanelAction,
      properties: panelActionProperties
    });
  };
  /**
   * Logs a UI panel view telemetry to telemetry and optionally to console
   * Should be used when a panel viewed is recorded from external/internal
   * triggers for e.g. page nivigation.
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logPanelViewEvent = function (properties) {
    var panelViewProperties = this._getPanelViewColumns(properties);
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] ").concat(EventBaseType.PanelView), panelViewProperties);
    }
    logUIEvent({
      eventName: EventBaseType.PanelView,
      properties: panelViewProperties
    });
  };
  /**
   * Logs an HTTP request/response times, network errors and data errors
   * to telemetry and optionally to console.
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logHttpRequestEvent = function (properties, eventType) {
    var httpRequestProperties = this._getHttpRequestColumns(properties);
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] HTTP Request: "), properties);
    }
    logHttpEvent({
      properties: httpRequestProperties,
      eventType: eventType
    });
  };
  /**
   * Logs a UI scenario to telemetry and optionally to console.
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logScenarioTrackerEvent = function (properties) {
    var eventProperties = this._getScenarioTrackerColumns(properties);
    if (this._logToConsole) {
      console.log("[".concat(new Date().toUTCString(), "] Scenario: ").concat(eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties[ScenarioColumns.ScenarioName]), eventProperties);
    }
    var scenarioName = eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties[ScenarioColumns.ScenarioName];
    if (eventProperties.error && scenarioName) {
      this.logException(eventProperties.error, "Scenario [".concat(scenarioName, "]"), SeverityLevel.Error, {
        Scenario: scenarioName
      });
    }
    logScenarioEvent({
      properties: eventProperties
    });
  };
  /**
   * Logs that a page, or a container is displayed to the user to telemetry and optionally to console
   * NOTES: DO NOT LOG PII (Personally Identifiable Information)
   */
  Logger.prototype.logPageView = function (properties, eventType) {
    var pageViewProperties = this._getPageViewColumns(properties);
    var eventName = eventType !== null && eventType !== void 0 ? eventType : EventType.Performance;
    logEvent(eventName, pageViewProperties);
  };
  /**
   * Appends telemetry common properties to the event log.
   * @param {T & Partial<TelemetryContext>} [properties] - event properties.
   */
  Logger.prototype._applyContextProperties = function () {
    var properties = this._context.customProperties;
    var navigatorProperties = getNavigationProperties();
    if (!properties[ContextColumnsBase.AppInfoPlatformId]) {
      properties[ContextColumnsBase.AppInfoPlatformId] = String(navigatorProperties.appPlatformId);
    }
    if (!properties[ContextColumnsBase.AppInfoClientType]) {
      properties[ContextColumnsBase.AppInfoClientType] = navigatorProperties.clientType;
    }
    if (!properties[ContextColumnsBase.UserAgent]) {
      properties[ContextColumnsBase.UserAgent] = navigatorProperties.userAgent;
    }
    properties[ContextColumnsBase.LoggerVersion] = "".concat(PackageInformation.PackageName, " ").concat(PackageInformation.PackageVersion);
    if (this._logToConsole) {
      console.log("[Logger][_applyContextProperties]: Apply custom context properties ", properties);
    }
    setCustomProperties(properties);
  };
  /**
   * Transforms panel view data to align with business telemetry schema.
   * @param data - panel view data.
   * @returns transformed panel view event data.
   */
  Logger.prototype._getPanelViewColumns = function (data) {
    var _a;
    var panelRegion = data.panelRegion,
      panelType = data.panelType,
      panelLaunchMethod = data.panelLaunchMethod,
      databag = data.databag,
      panelUri = data.panelUri;
    var event = __assign((_a = {}, _a[UserBiColumns.PanelRegion] = panelRegion, _a[UserBiColumns.PanelType] = panelType, _a[UserBiColumns.PanelLaunchMethod] = panelLaunchMethod, _a[UserBiColumns.PanelUri] = panelUri, _a), databag);
    return event;
  };
  Logger.prototype._getPageViewColumns = function (data) {
    var name = data.name,
      hostname = data.hostname,
      contentLength = data.contentLength,
      duration = data.duration,
      databag = data.databag,
      fcp = data.fcp,
      refUri = data.refUri,
      uri = data.uri;
    return __assign({
      SourceComponent: name,
      contentLength: contentLength,
      hostname: hostname,
      duration: duration,
      fcp: fcp,
      refUri: refUri,
      uri: uri
    }, databag);
  };
  /**
   * Transforms data to align with business telemetry schema for panel action event.
   * @param data - panel action properties
   * @returns transformed panel action event data.
   */
  Logger.prototype._getPanelActionColumns = function (data) {
    var _a;
    var actionGesture = data.actionGesture,
      actionOutcome = data.actionOutcome,
      actionScenario = data.actionScenario,
      actionScenarioType = data.actionScenarioType,
      moduleName = data.moduleName,
      moduleSummary = data.moduleSummary,
      databag = data.databag;
    return __assign(__assign((_a = {}, _a[UserBiColumns.Gesture] = actionGesture, _a[UserBiColumns.ActionOutcome] = actionOutcome, _a[UserBiColumns.Scenario] = actionScenario, _a[UserBiColumns.ScenarioType] = actionScenarioType, _a[UserBiColumns.ModuleName] = moduleName, _a[UserBiColumns.ModuleSummary] = moduleSummary, _a), this._getPanelViewColumns(data)), databag);
  };
  /**
   * Extracts only the peroperties to be pushed down to telemetry.
   * @param data  - middle tier request properties.
   * @returns middle tier request scenario data columns.
   */
  Logger.prototype._getHttpRequestColumns = function (data) {
    var _a;
    var hostname = data.hostname,
      contentLength = data.contentLength,
      method = data.method,
      requestCreatedTime = data.requestCreatedTime,
      requestResult = data.requestResult,
      resultCode = data.resultCode,
      duration = data.duration,
      start = data.start,
      databag = data.databag;
    return __assign((_a = {}, _a[HttpColumns.Hostname] = hostname, _a[HttpColumns.ContentLength] = contentLength, _a[HttpColumns.Method] = method, _a[HttpColumns.RequestCreatedTime] = requestCreatedTime, _a[HttpColumns.RequestResult] = requestResult, _a[HttpColumns.ResultCode] = resultCode, _a[HttpColumns.Duration] = duration, _a[HttpColumns.Start] = start, _a), databag);
  };
  /**
   * Extracts only the peroperties to be pushed down to telemetry.
   * @param data - page load request data.
   * @returns page load scenario columns.
   */
  Logger.prototype._getScenarioTrackerColumns = function (data) {
    var _a;
    var _b = data,
      _c = ScenarioColumns.ScenarioName,
      scenarioName = _b[_c],
      _d = ScenarioColumns.ScenarioStep,
      step = _b[_d],
      _e = ScenarioColumns.ScenarioStatus,
      status = _b[_e],
      elapsed = _b.elapsed,
      error = _b.error,
      errorCode = _b.errorCode,
      delta = _b.delta,
      stepDelta = _b.stepDelta,
      id = _b.id,
      startReason = _b.startReason,
      statusCode = _b.statusCode,
      databag = _b.databag;
    return __assign((_a = {}, _a[ScenarioColumns.ScenarioName] = scenarioName, _a[ScenarioColumns.ScenarioStep] = step, _a[ScenarioColumns.ScenarioStatus] = status, _a[ScenarioColumns.Delta] = delta, _a[ScenarioColumns.StepDelta] = stepDelta, _a[ScenarioColumns.Elapsed] = elapsed, _a[ScenarioColumns.Error] = error, _a[ScenarioColumns.ErrorCode] = errorCode, _a[ScenarioColumns.StartReason] = startReason, _a[ScenarioColumns.StatusCode] = statusCode, _a.id = id, _a), databag);
  };
  return Logger;
}();
var logger = Logger.getInstance();

/**
 * A class designed to be used by Components to track a scenario.
 *
 * "mark()" method marks a telemetry scenario. (e.g. the Component starts loading)
 * or logs additional events on that scenario.
 * "mesasure()" method logs telemetry scenario when it is done and measures the duration and other metrics etc. (e.g. the Component has loaded)
 */
var ScenarioTracker = /** @class */function () {
  function ScenarioTracker() {
    var _this = this;
    this.mark = function (_a) {
      var _b;
      var scenarioName = _a.scenarioName,
        databag = _a.databag,
        step = _a.step,
        status = _a.status;
      var telemetryEvent = _this.trackerMap.get(scenarioName);
      if (!telemetryEvent) {
        var startTime = new Date();
        var id = v4();
        logger.info("[ScenarioTracker] scenario [".concat(scenarioName, "]: has started."));
        telemetryEvent = (_b = {
          id: id
        }, _b[ScenarioColumns.ScenarioName] = scenarioName, _b[ScenarioColumns.ScenarioStep] = TelemetryScenarioStep.Start, _b[ScenarioColumns.ScenarioStatus] = TelemetryScenarioStatus.Init, _b.startTime = startTime, _b.lastUpdatedTime = startTime, _b.elapsed = 1, _b.stepDelta = 0, _b.databag = databag, _b);
        _this.trackerMap.set(scenarioName, telemetryEvent);
        logger.logScenarioTrackerEvent(telemetryEvent);
      } else {
        logger.info("[ScenarioTracker] scenario [".concat(scenarioName, "]: has already started. Adding a step event."));
        var telemetryEvent_1 = _this.trackerMap.get(scenarioName);
        var currentDateTime = new Date();
        telemetryEvent_1.elapsed = telemetryEvent_1.elapsed += 1;
        telemetryEvent_1.lastUpdatedTime = currentDateTime;
        telemetryEvent_1[ScenarioColumns.ScenarioStep] = step;
        telemetryEvent_1[ScenarioColumns.ScenarioStatus] = status;
        telemetryEvent_1.stepDelta = !telemetryEvent_1.stepDelta ? +currentDateTime - +telemetryEvent_1.startTime : +currentDateTime - +telemetryEvent_1.stepDelta;
        if (databag) {
          telemetryEvent_1.databag = databag;
        }
        _this.trackerMap.set(scenarioName, telemetryEvent_1);
        logger.logScenarioTrackerEvent(telemetryEvent_1);
      }
      return telemetryEvent;
    };
    this.trackerMap = new Map();
  }
  ScenarioTracker.prototype.measure = function (_a) {
    var _b;
    var scenarioName = _a.scenarioName,
      error = _a.error,
      databag = _a.databag,
      status = _a.status,
      errorCode = _a.errorCode;
    var finishTime = new Date();
    var telemetryEvent = this.trackerMap.get(scenarioName);
    if (!telemetryEvent) {
      logger.error("Trying to call measure without previously calling start for scenario ".concat(scenarioName, "."));
    } else {
      var stepDelta = +finishTime - +telemetryEvent.lastUpdatedTime;
      var duration = +finishTime - +telemetryEvent.startTime;
      var scenarioStatus = status !== null && status !== void 0 ? status : telemetryEvent[ScenarioColumns.ScenarioStatus];
      telemetryEvent.elapsed ? telemetryEvent.elapsed += 1 : telemetryEvent.elapsed = 1;
      telemetryEvent.lastUpdatedTime = finishTime;
      telemetryEvent.finishTime = finishTime;
      if (databag) {
        telemetryEvent.databag = databag;
      }
      if (error) {
        telemetryEvent.error = error;
        telemetryEvent.errorCode = errorCode;
        if (!status) {
          scenarioStatus = TelemetryScenarioStatus.Failure;
        }
      }
      logger.logScenarioTrackerEvent(__assign(__assign({}, telemetryEvent), (_b = {}, _b[ScenarioColumns.ScenarioName] = scenarioName, _b.id = telemetryEvent.id, _b[ScenarioColumns.ScenarioStep] = TelemetryScenarioStep.Finish, _b[ScenarioColumns.ScenarioStatus] = scenarioStatus, _b.stepDelta = stepDelta, _b.delta = duration, _b.elapsed = telemetryEvent.elapsed, _b)));
      this.trackerMap.delete(scenarioName);
      return telemetryEvent;
    }
  };
  return ScenarioTracker;
}();

export { ActionGesture, AriaTelemetryClient, ContextColumnsBase, EventBaseType, EventType, HttpColumns, NetworkState, PackageInformation, PanelActionOutcome, PanelLaunchMethod, PanelRegion, PanelViewOutcome, ScenarioColumns, ScenarioTracker, SeverityLevel, TelemetryScenarioStatus, TelemetryScenarioStep, UserBiColumns, flushTelemetry, getClients, initializeTelemetryClient, logEvent, logException, logHttpEvent, logPageView, logScenarioEvent, logTrace, logUIEvent, logger, queueEvent, setCommonProperties, setCustomProperties, updateToCompliantAriaClient };
